// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6e7f126a","239":"fd1b9c39","453":"afc6fbd2","732":"035068a7"}[chunkId] + ".chunk.js";
};